import React from 'react';
import chatPerson from "../../../images/img/chat-person.png"


const MessageA3 = (props) => {


    return (
        <> <div style={{ display: 'flex',width:'100%' }}>
            {/* {props.index === 0 && <div className="chat-person" style={{ marginTop: '10px' }}>
                <img src={chatPerson} alt="" /> </div>}

            {props.index === 0 ?
                <>
                    <div className="chat-text" style={{ margin: '10px 0px' }} dangerouslySetInnerHTML={{__html: props.item.text}}>
                     
                          </div>
                </>
                :
                <>
                    <div className="chat-text" style={{ margin: '10px 0px 10px 40px' }} dangerouslySetInnerHTML={{__html: props.item.text}} >
                       
                         </div>
                </>
            } */}
            <div className="chat-person" style={{ marginTop: '10px' }}>
                <img src={chatPerson} alt="" /> </div>
            <div className="chat-text" style={{ margin: '10px 10px' }} dangerouslySetInnerHTML={{ __html: props.item.text }}>

            </div>

        </div>
        </>
    )
}


export default MessageA3;